import { Action } from '@ngrx/store';
import { TechnicalError } from '@dch/products-business-logic';

export const GET_PUBLIC_WIFI_PRODUCTS = 'GET_PUBLIC_WIFI_PRODUCTS';
export const GET_PUBLIC_WIFI_PRODUCTS_SUCCESS =
  'GET_PUBLIC_WIFI_PRODUCTS_SUCCESS';
export const GET_PUBLIC_WIFI_PRODUCTS_FAILED =
  'GET_PUBLIC_WIFI_PRODUCTS_FAILED';

export const GET_PUBLIC_WIFI_ACCOUNTS = 'GET_PUBLIC_WIFI_ACCOUNTS';
export const GET_PUBLIC_WIFI_ACCOUNTS_SUCCESS =
  'GET_PUBLIC_WIFI_ACCOUNTS_SUCCESS';
export const GET_PUBLIC_WIFI_ACCOUNTS_FAILED =
  'GET_PUBLIC_WIFI_ACCOUNTS_FAILED';

export const CREATE_PUBLIC_WIFI_LOGIN_ALIAS = 'CREATE_PUBLIC_WIFI_LOGIN_ALIAS';
export const CREATE_PUBLIC_WIFI_LOGIN_ALIAS_SUCCESS =
  'CREATE_PUBLIC_WIFI_LOGIN_ALIAS_SUCCESS';
export const CREATE_PUBLIC_WIFI_LOGIN_ALIAS_FAILED =
  'CREATE_PUBLIC_WIFI_LOGIN_ALIAS_FAILED';

export const UPDATE_PUBLIC_WIFI_LOGIN_ALIAS = 'UPDATE_PUBLIC_WIFI_LOGIN_ALIAS';
export const UPDATE_PUBLIC_WIFI_LOGIN_ALIAS_SUCCESS =
  'UPDATE_PUBLIC_WIFI_LOGIN_ALIAS_SUCCESS';
export const UPDATE_PUBLIC_WIFI_LOGIN_ALIAS_FAILED =
  'UPDATE_PUBLIC_WIFI_LOGIN_ALIAS_FAILED';

export const UPDATE_PUBLIC_WIFI_PASSWORD = 'UPDATE_PUBLIC_WIFI_PASSWORD';
export const UPDATE_PUBLIC_WIFI_PASSWORD_SUCCESS =
  'UPDATE_PUBLIC_WIFI_PASSWORD_SUCCESS';
export const UPDATE_PUBLIC_WIFI_PASSWORD_FAILED =
  'UPDATE_PUBLIC_WIFI_PASSWORD_FAILED';

export const RESET_PUBLIC_WIFI_MANAGE_VALUES =
  'RESET_PUBLIC_WIFI_MANAGE_VALUES';
export const RESET_PUBLIC_WIFI_CREATE_VALUES =
  'RESET_PUBLIC_WIFI_CREATE_VALUES';

export class GetPublicWifiProducts implements Action {
  type = GET_PUBLIC_WIFI_PRODUCTS;

  constructor(public payload?: any) {}
}

export class GetPublicWifiProductsSuccess implements Action {
  type = GET_PUBLIC_WIFI_PRODUCTS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetPublicWifiProductsFailed implements Action {
  type = GET_PUBLIC_WIFI_PRODUCTS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class GetPublicWifiAccounts implements Action {
  type = GET_PUBLIC_WIFI_ACCOUNTS;

  constructor(public payload?: any) {}
}

export class GetPublicWifiAccountsSuccess implements Action {
  type = GET_PUBLIC_WIFI_ACCOUNTS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetPublicWifiAccountsFailed implements Action {
  type = GET_PUBLIC_WIFI_ACCOUNTS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class CreatePublicWifiLoginAlias implements Action {
  type = CREATE_PUBLIC_WIFI_LOGIN_ALIAS;

  constructor(public payload?: any) {}
}

export class CreatePublicWifiLoginAliasSuccess implements Action {
  type = CREATE_PUBLIC_WIFI_LOGIN_ALIAS_SUCCESS;

  constructor(public payload: any) {}
}

export class CreatePublicWifiLoginAliasFailed implements Action {
  type = CREATE_PUBLIC_WIFI_LOGIN_ALIAS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class UpdatePublicWifiLoginAlias implements Action {
  type = UPDATE_PUBLIC_WIFI_LOGIN_ALIAS;

  constructor(public payload?: any) {}
}

export class UpdatePublicWifiLoginAliasSuccess implements Action {
  type = UPDATE_PUBLIC_WIFI_LOGIN_ALIAS_SUCCESS;

  constructor(public payload: any) {}
}

export class UpdatePublicWifiLoginAliasFailed implements Action {
  type = UPDATE_PUBLIC_WIFI_LOGIN_ALIAS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class UpdatePublicWifiPassword implements Action {
  type = UPDATE_PUBLIC_WIFI_PASSWORD;

  constructor(public payload?: any) {}
}

export class UpdatePublicWifiPasswordSuccess implements Action {
  type = UPDATE_PUBLIC_WIFI_PASSWORD_SUCCESS;

  constructor(public payload: any) {}
}

export class UpdatePublicWifiPasswordFailed implements Action {
  type = UPDATE_PUBLIC_WIFI_PASSWORD_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class ResetPublicWifiManageValues implements Action {
  type = RESET_PUBLIC_WIFI_MANAGE_VALUES;

  constructor(public payload?: any) {}
}

export class ResetPublicWifiCreateValues implements Action {
  type = RESET_PUBLIC_WIFI_CREATE_VALUES;

  constructor(public payload?: any) {}
}

export type Actions =
  | GetPublicWifiProducts
  | GetPublicWifiProductsSuccess
  | GetPublicWifiProductsFailed
  | GetPublicWifiAccounts
  | GetPublicWifiAccountsSuccess
  | GetPublicWifiAccountsFailed
  | UpdatePublicWifiLoginAlias
  | UpdatePublicWifiLoginAliasSuccess
  | UpdatePublicWifiLoginAliasFailed
  | UpdatePublicWifiPassword
  | UpdatePublicWifiPasswordSuccess
  | UpdatePublicWifiPasswordFailed
  | ResetPublicWifiManageValues
  | ResetPublicWifiCreateValues;
